module.exports = __webpack_public_path__ + "img/pie-chart-line.7a5f42d5.png";